import { Container, makeStyles } from "@material-ui/core";

import { useAdmin } from "src/components/LoggedInAdminProvider";
import PageTitle from "src/components/PageTitle";
import { useFeatureFlag } from "src/util/featureFlags";

import ApprovalConfiguration from "./ApprovalConfiguration";
import Basics from "./Basics";
import Deactivate from "./Deactivate";
import FeatureFlags from "./FeatureFlags";
import NumberRotation from "./NumberRotation";
import OutboundPool from "./OutboundPool";
import UploadLimit from "./UploadLimit";
import TwilioConfiguration from "./twilioConfiguration";

const useStyles = makeStyles(theme => ({
  section: {
    marginBottom: theme.spacing(4)
  }
}));

export default function Settings(): JSX.Element {
  const classes = useStyles();
  const admin = useAdmin();
  const customTwilioIntegrationEnabled = useFeatureFlag(
    "customTwilioIntegration"
  );
  const disableClickerEnabled = useFeatureFlag("disableClicker");

  return (
    <Container>
      <PageTitle title="Organization Settings" />
      <div className={classes.section}>
        <Basics />
      </div>
      {admin?.isStaff && (
        <>
          <div className={classes.section}>
            <FeatureFlags />
          </div>
          <div className={classes.section}>
            <NumberRotation />
          </div>
          <div className={classes.section}>
            <UploadLimit />
          </div>
          <div className={classes.section}>
            <OutboundPool />
          </div>
          {customTwilioIntegrationEnabled && (
            <div className={classes.section}>
              <TwilioConfiguration />
            </div>
          )}
          {disableClickerEnabled && (
            <div className={classes.section}>
              <ApprovalConfiguration />
            </div>
          )}
          <div className={classes.section}>
            <Deactivate />
          </div>
        </>
      )}
    </Container>
  );
}
